import revive_payload_client_4sVQNw7RlN from "/home/forge/amosweb.de/releases/20250506200506/newsletters/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/home/forge/amosweb.de/releases/20250506200506/newsletters/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/home/forge/amosweb.de/releases/20250506200506/newsletters/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/home/forge/amosweb.de/releases/20250506200506/newsletters/node_modules/nuxt/dist/app/plugins/payload.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/home/forge/amosweb.de/releases/20250506200506/newsletters/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import components_plugin_KR1HBZs4kY from "/home/forge/amosweb.de/releases/20250506200506/newsletters/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/home/forge/amosweb.de/releases/20250506200506/newsletters/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import i18n_yfWm7jX06p from "/home/forge/amosweb.de/releases/20250506200506/newsletters/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.mjs";
import plugin_8SbxDRbG6Y from "/home/forge/amosweb.de/releases/20250506200506/newsletters/node_modules/dayjs-nuxt/dist/runtime/plugin.mjs";
import chunk_reload_client_UciE0i6zes from "/home/forge/amosweb.de/releases/20250506200506/newsletters/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import axios_sVCuMR6hEC from "/home/forge/amosweb.de/releases/20250506200506/newsletters/plugins/axios.js";
import element_plus_elM4AXquKi from "/home/forge/amosweb.de/releases/20250506200506/newsletters/plugins/element-plus.js";
import fontAwesome_ZfwYhjRo2I from "/home/forge/amosweb.de/releases/20250506200506/newsletters/plugins/fontAwesome.js";
import helperFunctions_G7RveuiYqj from "/home/forge/amosweb.de/releases/20250506200506/newsletters/plugins/helperFunctions.js";
import notify_Oxf81SlxaN from "/home/forge/amosweb.de/releases/20250506200506/newsletters/plugins/notify.js";
import sweetalert2_client_W93Y1gtp8C from "/home/forge/amosweb.de/releases/20250506200506/newsletters/plugins/sweetalert2.client.js";
import transitions_TiacYEpi6A from "/home/forge/amosweb.de/releases/20250506200506/newsletters/plugins/transitions.js";
import vee_validate_K3WwmJMPDb from "/home/forge/amosweb.de/releases/20250506200506/newsletters/plugins/vee-validate.js";
import vuex_owYp5qnaH8 from "/home/forge/amosweb.de/releases/20250506200506/newsletters/plugins/vuex.js";
import ziggy_861J4JMJOx from "/home/forge/amosweb.de/releases/20250506200506/newsletters/plugins/ziggy.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  check_outdated_build_client_8vK7RkfGxZ,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  i18n_yfWm7jX06p,
  plugin_8SbxDRbG6Y,
  chunk_reload_client_UciE0i6zes,
  axios_sVCuMR6hEC,
  element_plus_elM4AXquKi,
  fontAwesome_ZfwYhjRo2I,
  helperFunctions_G7RveuiYqj,
  notify_Oxf81SlxaN,
  sweetalert2_client_W93Y1gtp8C,
  transitions_TiacYEpi6A,
  vee_validate_K3WwmJMPDb,
  vuex_owYp5qnaH8,
  ziggy_861J4JMJOx
]